"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UWPInfo = (function () {
    function UWPInfo(winRtBridge) {
        this.winRtBridge = winRtBridge;
    }
    UWPInfo.prototype.initialise = function () {
        this.deviceType = 'Console';
        this.uniqueDeviceId = this.winRtBridge.getDeviceId();
        this.deviceModel = this.winRtBridge.getDeviceFamily();
        this.operatingSystemName = 'Windows 10';
        this.operatingSystemVersion = this.deviceVersion = this.winRtBridge.getDeviceFamilyVersion();
        this.browserVersion = '1';
        this.browserName = 'Microsoft Edge';
        this.deviceManufacturer = 'Microsoft';
        this.deviceBrand = 'Xbox';
        this.userFriendlyName = 'Xbox One';
        return Promise.resolve();
    };
    return UWPInfo;
}());
exports.UWPInfo = UWPInfo;
